var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsCollapseInboxEnabled24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12035 4C4.54405 4 4.07687 4.46718 4.07687 5.04348V18.9565C4.07687 19.5328 4.54405 20 5.12035 20C5.69665 20 6.16383 19.5328 6.16383 18.9565V5.04348C6.16383 4.46718 5.69665 4 5.12035 4ZM13.9847 5.83372C13.5732 5.43027 12.9125 5.43681 12.5091 5.84833L7.39457 11.0651C7.01484 11.4525 6.99518 12.0661 7.34935 12.477L12.4639 18.4098C12.8402 18.8463 13.499 18.8951 13.9355 18.5188C14.372 18.1425 14.4208 17.4836 14.0445 17.0472L10.4169 12.8391H18.8797C19.456 12.8391 19.9232 12.3719 19.9232 11.7956C19.9232 11.2193 19.456 10.7522 18.8797 10.7522H10.624L13.9993 7.30935C14.4028 6.89783 14.3962 6.23717 13.9847 5.83372Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsCollapseInboxEnabled24);
export default __webpack_public_path__ + "static/media/actions-collapse-inbox-enabled-24.59b9dc89869315fc0db82960a4f74ac3.svg";
export { ForwardRef as ReactComponent };